/* eslint-disable react-hooks/exhaustive-deps */
import { Divider } from 'antd'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import { showNotification } from 'src/core/helpers'
import { Deposit } from 'src/core/models'
import { depositsListColumns } from 'src/core/table-columns'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import DepositListHeader from './DepositListHeader/DepositListHeader'
import { CustomCard, CustomTable, DepositsDetailsModal } from 'src/components'
import {
  loadingCurrenciesSelector,
  filteredDepositsSelector,
  resetRemoveDepositsState,
  getDepositsListSelector,
  removeDepositsSelector,
  setSelectedDeposits,
  depositListSelector,
  getDepositsList,
  getCurrencyList
} from 'src/features'

const DepositsPageContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const [newDeposit, setNewDeposit] = useState<Deposit>(null)
  const { id } = useRouter().query

  const depositList = useAppSelector(depositListSelector)
  const { loading: loadingDeposits } = useAppSelector(getDepositsListSelector)
  const loadingCurrencies = useAppSelector(loadingCurrenciesSelector)
  const filteredDeposits = useAppSelector(filteredDepositsSelector)
  const {
    loading: loadingDeletion,
    success: successDeletion,
    error: errorDeletion
  } = useAppSelector(removeDepositsSelector)
  const isLoading = loadingDeposits || loadingCurrencies || loadingDeletion

  const rowSelection = {
    onChange: (_: any, selectedDeposits: Deposit[]) => {
      dispatch(setSelectedDeposits(selectedDeposits))
    },
  }

  useEffect(() => {
    dispatch(getDepositsList())
    dispatch(getCurrencyList())
  }, [dispatch])

  useEffect(() => {
    if (successDeletion) {
      showNotification('success', t('Deposits.RemoveSuccess'))
      dispatch(resetRemoveDepositsState())
    }
  }, [successDeletion])

  useEffect(() => {
    if (errorDeletion) {
      showNotification('error', t('Deposits.RemoveError'))
      dispatch(resetRemoveDepositsState())
    }
  }, [errorDeletion])

  useEffect(() => {
    if (id && depositList.length > 0) {
      setIsModalVisible(true)
      setNewDeposit(depositList.find(x => x.id === Number(id)))
    }
  }, [depositList])

  return (
    <>
      <CustomCard loading={isLoading}>
        <DepositListHeader depositsLength={filteredDeposits.length} />
        <Divider />
        <CustomTable
          columns={depositsListColumns}
          dataSource={filteredDeposits}
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }}
        />
      </CustomCard>

      <DepositsDetailsModal
        isModalVisible={isModalVisible}
        handleCancel={() => setIsModalVisible(false)}
        deposit={newDeposit}
      />
    </>
  )
}

export default DepositsPageContent
